import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import Coordinate from './Coordinate';
import IllegalArgumentException from '../../../../java/lang/IllegalArgumentException';
var CoordinateXY = /*#__PURE__*/function (_Coordinate) {
  _inherits(CoordinateXY, _Coordinate);
  function CoordinateXY() {
    var _this;
    _classCallCheck(this, CoordinateXY);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(CoordinateXY).call(this));
    CoordinateXY.constructor_.apply(_assertThisInitialized(_assertThisInitialized(_this)), arguments);
    return _this;
  }
  _createClass(CoordinateXY, [{
    key: "setOrdinate",
    value: function setOrdinate(ordinateIndex, value) {
      switch (ordinateIndex) {
        case CoordinateXY.X:
          this.x = value;
          break;
        case CoordinateXY.Y:
          this.y = value;
          break;
        default:
          throw new IllegalArgumentException('Invalid ordinate index: ' + ordinateIndex);
      }
    }
  }, {
    key: "getZ",
    value: function getZ() {
      return Coordinate.NULL_ORDINATE;
    }
  }, {
    key: "getOrdinate",
    value: function getOrdinate(ordinateIndex) {
      switch (ordinateIndex) {
        case CoordinateXY.X:
          return this.x;
        case CoordinateXY.Y:
          return this.y;
      }
      throw new IllegalArgumentException('Invalid ordinate index: ' + ordinateIndex);
    }
  }, {
    key: "setZ",
    value: function setZ(z) {
      throw new IllegalArgumentException('CoordinateXY dimension 2 does not support z-ordinate');
    }
  }, {
    key: "copy",
    value: function copy() {
      return new CoordinateXY(this);
    }
  }, {
    key: "toString",
    value: function toString() {
      return '(' + this.x + ', ' + this.y + ')';
    }
  }, {
    key: "setCoordinate",
    value: function setCoordinate(other) {
      this.x = other.x;
      this.y = other.y;
      this.z = other.getZ();
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      if (arguments.length === 0) {
        Coordinate.constructor_.call(this);
      } else if (arguments.length === 1) {
        if (arguments[0] instanceof CoordinateXY) {
          var coord = arguments[0];
          Coordinate.constructor_.call(this, coord.x, coord.y);
        } else if (arguments[0] instanceof Coordinate) {
          var _coord = arguments[0];
          Coordinate.constructor_.call(this, _coord.x, _coord.y);
        }
      } else if (arguments.length === 2) {
        var x = arguments[0],
          y = arguments[1];
        Coordinate.constructor_.call(this, x, y, Coordinate.NULL_ORDINATE);
      }
    }
  }]);
  return CoordinateXY;
}(Coordinate);
export { CoordinateXY as default };
CoordinateXY.X = 0;
CoordinateXY.Y = 1;
CoordinateXY.Z = -1;
CoordinateXY.M = -1;